import CreateInvoiceModal from '../../../modals/invoice/CreateInvoiceModal';
import InvoiceReasonFlagsHelpModal from '../../../modals/invoice/InvoiceReasonFlagsHelpModal';
import InvoiceStatusHelpModal from '../../../modals/invoice/InvoiceStatusHelpModal';
import PartsInvoicingUserGuideModal from '../../../modals/invoice/PartsInvoicingUserGuideModal';
import InvoicingDemoResetConfirmModal from '../../../modals/invoice/InvoicingDemoResetConfirmModal';
import type { InvoicesListPageModel } from './useInvoicesListPage';

export function InvoicesListModals({ page }: { page: InvoicesListPageModel }) {
    const {
        isReasonHelpOpen,
        onReasonHelpClose,
        isStatusHelpOpen,
        onStatusHelpClose,
        isPartsInvoicingGuideOpen,
        onPartsInvoicingGuideClose,
        isCreateModalOpen,
        onCreateModalClose,
        isDemoResetOpen,
        onDemoResetClose,
        handleConfirmDemoReset,
        resetInvoicingDemoMutation,
    } = page;

    return (
        <>
            <InvoiceReasonFlagsHelpModal isOpen={isReasonHelpOpen} onClose={onReasonHelpClose} />
            <InvoiceStatusHelpModal isOpen={isStatusHelpOpen} onClose={onStatusHelpClose} />
            <PartsInvoicingUserGuideModal
                isOpen={isPartsInvoicingGuideOpen}
                onClose={onPartsInvoicingGuideClose}
            />
            <CreateInvoiceModal
                isOpen={isCreateModalOpen}
                onClose={onCreateModalClose}
            />
            <InvoicingDemoResetConfirmModal
                isOpen={isDemoResetOpen}
                onClose={onDemoResetClose}
                isLoading={resetInvoicingDemoMutation.isPending}
                onConfirm={handleConfirmDemoReset}
            />
        </>
    );
}
